var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "core-js/modules/es6.regexp.to-string", "core-js/modules/es6.date.to-string", "core-js/modules/es6.object.to-string", "@babel/runtime-corejs2/core-js/reflect/construct", "@babel/runtime-corejs2/helpers/extends", "@babel/runtime-corejs2/helpers/classCallCheck", "@babel/runtime-corejs2/helpers/createClass", "@babel/runtime-corejs2/helpers/assertThisInitialized", "@babel/runtime-corejs2/helpers/inherits", "@babel/runtime-corejs2/helpers/possibleConstructorReturn", "@babel/runtime-corejs2/helpers/getPrototypeOf", "@babel/runtime-corejs2/helpers/defineProperty", "react", "prop-types", "classnames", "emotion-theming", "../../themes", "../../Teasers/TeaserMain/TeaserMain", "../../UI/TitlesElement/TitlesElement", "../../Sliders/Bullets/Bullets", "../../Sliders/HOC/withAutoSliding", "../../../../breakpoints"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("core-js/modules/es6.regexp.to-string"), require("core-js/modules/es6.date.to-string"), require("core-js/modules/es6.object.to-string"), require("@babel/runtime-corejs2/core-js/reflect/construct"), require("@babel/runtime-corejs2/helpers/extends"), require("@babel/runtime-corejs2/helpers/classCallCheck"), require("@babel/runtime-corejs2/helpers/createClass"), require("@babel/runtime-corejs2/helpers/assertThisInitialized"), require("@babel/runtime-corejs2/helpers/inherits"), require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"), require("@babel/runtime-corejs2/helpers/getPrototypeOf"), require("@babel/runtime-corejs2/helpers/defineProperty"), require("react"), require("prop-types"), require("classnames"), require("emotion-theming"), require("../../themes"), require("../../Teasers/TeaserMain/TeaserMain"), require("../../UI/TitlesElement/TitlesElement"), require("../../Sliders/Bullets/Bullets"), require("../../Sliders/HOC/withAutoSliding"), require("../../../../breakpoints"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.es6Regexp, global.es6Date, global.es6Object, global.construct, global._extends, global.classCallCheck, global.createClass, global.assertThisInitialized, global.inherits, global.possibleConstructorReturn, global.getPrototypeOf, global.defineProperty, global.react, global.propTypes, global.classnames, global.emotionTheming, global.themes, global.TeaserMain, global.TitlesElement, global.Bullets, global.withAutoSliding, global.breakpoints);
    global.GuideMainSlider = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _es6Regexp, _es6Date, _es6Object, _construct, _extends2, _classCallCheck2, _createClass2, _assertThisInitialized2, _inherits2, _possibleConstructorReturn2, _getPrototypeOf2, _defineProperty2, _react, _propTypes, _classnames, _emotionTheming, _themes, _TeaserMain, _TitlesElement, _Bullets, _withAutoSliding, _breakpoints) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _construct = _interopRequireDefault(_construct);
  _extends2 = _interopRequireDefault(_extends2);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _assertThisInitialized2 = _interopRequireDefault(_assertThisInitialized2);
  _inherits2 = _interopRequireDefault(_inherits2);
  _possibleConstructorReturn2 = _interopRequireDefault(_possibleConstructorReturn2);
  _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf2);
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _react = _interopRequireWildcard(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _classnames = _interopRequireDefault(_classnames);
  _themes = _interopRequireDefault(_themes);
  _TeaserMain = _interopRequireDefault(_TeaserMain);
  _TitlesElement = _interopRequireDefault(_TitlesElement);
  _Bullets = _interopRequireDefault(_Bullets);
  _withAutoSliding = _interopRequireDefault(_withAutoSliding);

  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

  var GuideMainSlider = /*#__PURE__*/function (_PureComponent) {
    (0, _inherits2.default)(GuideMainSlider, _PureComponent);

    var _super = _createSuper(GuideMainSlider);

    function GuideMainSlider(props) {
      var _this;

      (0, _classCallCheck2.default)(this, GuideMainSlider);
      _this = _super.call(this, props);
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onBulletClick", function (slideIndex) {
        var teaser = _this.root.querySelectorAll('.teaser-focus')[slideIndex];

        _this.props.injectedProp.onBulletClick(slideIndex, teaser);
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onBulletPress", function (slideIndex) {
        var teaser = _this.root.querySelectorAll('.teaser-focus')[slideIndex];

        _this.props.injectedProp.onBulletPress(slideIndex, teaser);
      });
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "init", function (root) {
        _this.root = root;
      });
      _this.state = {
        width: global.innerWidth || 1200
      };
      return _this;
    }

    (0, _createClass2.default)(GuideMainSlider, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.setState({
          width: global.innerWidth
        }); // get the right value of screen width in ssr
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props = this.props,
            _this$props$injectedP = _this$props.injectedProp,
            touchStart = _this$props$injectedP.touchStart,
            touchEnd = _this$props$injectedP.touchEnd,
            autoplay = _this$props$injectedP.autoplay,
            onBulletNavigate = _this$props$injectedP.onBulletNavigate,
            slideIndex = _this$props$injectedP.slideIndex,
            togglePlayButton = _this$props$injectedP.togglePlayButton,
            mouseFocus = _this$props$injectedP.mouseFocus,
            pauseAutoplay = _this$props$injectedP.pauseAutoplay,
            unpauseAutoplay = _this$props$injectedP.unpauseAutoplay,
            labels = _this$props.labels,
            showDate = _this$props.showDate,
            teasers = _this$props.teasers,
            theme = _this$props.theme;
        return /*#__PURE__*/_react.default.createElement(_emotionTheming.ThemeProvider, {
          theme: _themes.default[theme]
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "guide-main-slider",
          onTouchStart: touchStart,
          onTouchEnd: touchEnd
        }, /*#__PURE__*/_react.default.createElement("h2", {
          className: "sr-only"
        }, labels.mainSliderLabel), teasers.length > 0 && /*#__PURE__*/_react.default.createElement(_Bullets.default, {
          autoplay: autoplay,
          labels: labels,
          onBulletClick: this.onBulletClick,
          onBulletNavigate: onBulletNavigate,
          onBulletPress: this.onBulletPress,
          pause: pauseAutoplay,
          slideIndex: slideIndex,
          teasers: teasers,
          togglePlayButton: togglePlayButton
        }), /*#__PURE__*/_react.default.createElement("div", {
          className: "guide-main-slider__inner",
          ref: this.init
        }, teasers.map(function (teaser, teaserIndex) {
          var visible = slideIndex === teaserIndex || _this2.state.width >= _breakpoints.nextBreakpoints.MEDIUM;
          return /*#__PURE__*/_react.default.createElement("div", {
            className: (0, _classnames.default)('guide-main-slider__slide', {
              'is-active': slideIndex === teaserIndex
            }),
            key: "slide-".concat(teaser.programId)
          }, /*#__PURE__*/_react.default.createElement(_TeaserMain.default, (0, _extends2.default)({
            ariaHidden: !visible,
            tabIndex: visible ? 0 : -1,
            className: "tvguide-highlight",
            focus: "guide",
            hover: "overlay",
            mouseFocus: mouseFocus,
            pause: pauseAutoplay,
            unpause: unpauseAutoplay,
            showDate: showDate,
            titlesElement: /*#__PURE__*/_react.default.createElement(_TitlesElement.default, {
              display: "TVGUIDE",
              title: teaser.title,
              subtitle: teaser.subtitle
            })
          }, teaser)));
        }))));
      }
    }]);
    return GuideMainSlider;
  }(_react.PureComponent);

  GuideMainSlider.propTypes = {
    injectedProp: _propTypes.default.shape().isRequired,
    labels: _propTypes.default.shape().isRequired,
    showDate: _propTypes.default.bool.isRequired,
    teasers: _propTypes.default.arrayOf(_propTypes.default.shape()).isRequired,
    theme: _propTypes.default.string.isRequired
  };

  var _default = (0, _withAutoSliding.default)(GuideMainSlider);

  _exports.default = _default;
});